import { getJourneyById } from '../../journey/selectors/get-journey-by-id';
import { sortOrderShowtimes } from '../../journey/utils/journey-order-showtime-utils';
import { getSortedJourneyOrderShowtimes } from '../../journey/utils/journey-utils';
export const sortJourneyIdsByShowtimeStartTime = (a, b) => {
    const journeyA = getJourneyById(a);
    const journeyB = getJourneyById(b);
    if (!journeyA || !journeyB)
        return 0;
    const showtimeA = getNextOrderShowtime(journeyA);
    const showtimeB = getNextOrderShowtime(journeyB);
    if (!showtimeA || !showtimeB)
        return 0;
    const sortedShowtimes = sortOrderShowtimes([showtimeA, showtimeB]);
    return sortedShowtimes[0] === showtimeA ? -1 : 1;
};
export const getNextOrderShowtime = (journey) => {
    const sortedShowtimes = getSortedJourneyOrderShowtimes(journey);
    if (!sortedShowtimes.length)
        return;
    return sortedShowtimes[0];
};
